import { z } from "zod";

const translationPath = "page.4uSiteApp.siteLoginContent.errors.";

const language = z.object({
  id: z.string(),
  name: z.string(),
  code: z.string().optional(),
});

const siteLoginContentLanguage = z
  .object({
    language: language.nullable(),
    documentText: z.string().nonempty(translationPath + "document_text"),
    linkLabel: z.string().optional().nullable(),
  })
  .superRefine((val, ctx) => {
    if (!val.language) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["language"],
        message: `${translationPath + "language"}`,
      });
    }
  });

export const SiteLoginContentSchema = z.object({
  name: z.string().nonempty(translationPath + "name"),
  presentationOrder: z.coerce
    .number({ invalid_type_error: translationPath + "presentation_order" })
    .int(translationPath + "presentation_order")
    .min(0, translationPath + "presentation_order"),
  enable: z.boolean(),
  linkUrl: z.string().optional().nullable(),
  siteLoginContentLanguages: z
    .array(siteLoginContentLanguage)
    .min(1, translationPath + "languages"),
});

export type TSiteLoginContentForm = z.infer<typeof SiteLoginContentSchema>;
